import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) =>({
    root: {
        height: '45px',
        display: 'flex',
        justifyContent: 'space-between',
      }
}));